var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPanas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9567 13.25C4.70611 9.12914 7.34856 7.62451 7.34856 7.62451C7.16368 9.82344 8.41328 11.5366 8.41328 11.5366C8.87286 11.3979 9.75007 10.7498 9.75007 10.7498C9.75007 11.5366 9.28721 13.249 9.28721 13.249C9.28721 13.249 10.9076 11.9961 11.4176 9.91522C11.927 7.8343 10.4473 5.74519 10.4473 5.74519C10.5365 7.21803 10.0382 8.66661 9.06201 9.77328C9.11085 9.7169 9.15183 9.65429 9.1833 9.58643C9.35867 9.23568 9.64026 8.32405 9.47537 6.21297C9.24328 3.2496 6.55822 2 6.55822 2C6.78965 3.80556 6.09569 4.22155 4.47009 7.64877C2.8445 11.0753 5.9567 13.25 5.9567 13.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanas);
export default __webpack_public_path__ + "static/media/panas.1eac0aa2811a2ca580638f4295387927.svg";
export { ForwardRef as ReactComponent };